import EmptyState from '@adsk/alloy-react-empty-state';
import { LinkButton } from '@adsk/alloy-react-button';
import LocalizationProvider from '../providers/LocalizationProvider';
import { translate } from '../helpers';

const ErrorPage = () => (
  <EmptyState
    illustrationType={EmptyState.ILLUSTRATION_TYPES.CRANE_CONSTRUCTION_GREY}
    title={translate('error.general')}
    description={translate('error.pageUnavailable')}
    size={EmptyState.SIZES.LARGE}
    style={{ height: '100%', justifyContent: 'center' }}
  >
    <LinkButton onClick={() => window.location.reload()}>{translate('error.tryAgain')}</LinkButton>
  </EmptyState>
);

const ErrorPageLocalized = () => (
  <LocalizationProvider>
    <ErrorPage />
  </LocalizationProvider>
);
export default ErrorPageLocalized;
